import { __assign } from "tslib";
import React, { useContext, useCallback, useEffect, } from 'react';
import Ruler from '../ruler';
import { ChartContext } from '../../contexts';
import { setXLabelsDimension, setYLabelsDimension, calculateAxisDimension, } from './utils';
import { Orientation } from '../../types';
var Axes = function (_a) {
    var xScale = _a.xScale, yScale = _a.yScale, xTitle = _a.xTitle, yTitle = _a.yTitle, layout = _a.layout, onComputeLayout = _a.onComputeLayout, initialMargins = _a.initialMargins, svgElement = _a.svgElement, _b = _a.useDynamicLayout, useDynamicLayout = _b === void 0 ? false : _b;
    var _c = useContext(ChartContext), theme = _c.theme, margins = _c.margins, svgDimensions = _c.svgDimensions, xScaleSettings = _c.xScaleSettings, yScaleSettings = _c.yScaleSettings;
    var xLabelsDimension = theme.axisY.enabled
        ? setXLabelsDimension({
            scale: xScale,
            axisTheme: theme.axisX,
            svgDimensions: svgDimensions,
        })
        : null;
    var yLabelsDimension = theme.axisY.enabled
        ? setYLabelsDimension({
            scale: yScale,
            axisTheme: theme.axisX,
            svgDimensions: svgDimensions,
        })
        : null;
    var computeLayout = useCallback(function () {
        var sizeAxisX = calculateAxisDimension({
            svgElement: svgElement.current,
            axisTheme: theme.axisX,
            orientation: Orientation.HORIZONTAL,
            axisTitle: xTitle,
        });
        var sizeAxisY = calculateAxisDimension({
            svgElement: svgElement.current,
            axisTheme: theme.axisY,
            orientation: Orientation.VERTICAL,
            axisTitle: yTitle,
        });
        onComputeLayout({
            top: initialMargins.top,
            right: initialMargins.right,
            left: initialMargins.left + sizeAxisY.width,
            bottom: initialMargins.bottom + sizeAxisX.height,
        });
    }, [xTitle, yTitle, theme, initialMargins]);
    useEffect(function () {
        if (useDynamicLayout) {
            computeLayout();
        }
    }, [
        useDynamicLayout,
        xLabelsDimension,
        yLabelsDimension,
        layout,
        initialMargins,
        xTitle,
        yTitle,
        yScaleSettings.formatLabel,
        xScaleSettings.formatLabel,
    ]);
    var axisX = theme.axisX.enabled && {
        x: 0,
        y: svgDimensions.height - margins.bottom + theme.axisX.padding,
        scale: xScale,
        scaleSettings: xScaleSettings,
        orientation: Orientation.HORIZONTAL,
        axisTitle: xTitle,
        labelDimension: xLabelsDimension,
    };
    var axisY = theme.axisY.enabled && {
        x: margins.left - theme.axisY.padding,
        y: 0,
        scale: yScale,
        scaleSettings: yScaleSettings,
        orientation: Orientation.VERTICAL,
        axisTitle: yTitle,
        labelDimension: yLabelsDimension,
    };
    return (React.createElement(React.Fragment, null,
        axisX && React.createElement(Ruler, __assign({}, axisX, theme.axisX)),
        axisY && React.createElement(Ruler, __assign({}, axisY, theme.axisY))));
};
export default Axes;
